import clsx from "clsx";
import * as React from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
	return (
		<textarea
			className={clsx(
				"flex min-h-[120px] w-full px-3 py-2.5 text-base rounded-md border-border border focus:border-focus-border focus:ring-2 ring-offset-0 focus:ring-focus-ring/30 outline-0 outline-none",
				{
					"bg-muted text-muted-foreground": props.disabled,
					"bg-background text-foreground": !props.disabled,
				},
				className,
			)}
			spellCheck={false}
			ref={ref}
			{...props}
		/>
	);
});
Textarea.displayName = "Textarea";

export { Textarea };
